import { Button } from '@goodlok/react-sdk'
import { Input, notify } from '@goodlok/ui'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { FunctionComponent, useState } from 'react'
import { thunder } from '../app/data/thunder'
import type { AdminShiftTileProps } from './AdminShiftTile'
import styles from './TipsForm.module.sass'

type TipsFormProps = {
	tipsCents: AdminShiftTileProps['day']['tipsCents']
	dayId: AdminShiftTileProps['day']['id']
}
export const TipsForm: FunctionComponent<TipsFormProps> = ({ dayId, tipsCents }) => {
	const [tips, setTips] = useState(tipsCents ?? 0)
	const queryClient = useQueryClient()

	const mutation = useMutation(
		async (data: { cents: number }) => {
			return thunder.admin('mutation')({
				updateTimetableDay: [
					{
						by: { id: dayId },
						data: { tipsCents: data.cents },
					},
					{
						ok: true,
						errorMessage: true,
					},
				],
			})
		},
		{
			onSuccess: (data) => {
				if (data.updateTimetableDay.ok) {
					queryClient.invalidateQueries(['adminPageData'])
					notify('Spropitné bylo aktualizováno', 'success')
				} else {
					notify('Nastala chyba při ukládání spropitného', 'error')
					console.error(data.updateTimetableDay.errorMessage)
				}
			},
		}
	)

	return (
		<div className={styles.wrapper}>
			<h3 className={styles.title}>Spropitné</h3>
			<form
				className={styles.controls}
				onSubmit={(event) => {
					event.preventDefault()
					mutation.mutate({ cents: tips })
				}}>
				<Input
					type="number"
					name="tips"
					label="Částka (Kč)"
					labelPosition="inside"
					size="compact"
					min={0}
					value={tips / 100}
					onChange={(event) => {
						setTips(parseInt(event.target.value) * 100)
					}}
				/>
				<div className={styles.button}>
					<Button type="submit" variant="primary" fullWidth disabled={tips === tipsCents}>
						Ok
					</Button>
				</div>
			</form>
		</div>
	)
}
